module.exports = __webpack_public_path__ + "static/media/ocean-and-ei.2d4c10ce.png";